<template>
    <slot></slot>
</template>

<script setup>
import { ref, provide, onMounted, watch, computed } from 'vue'

const theme = ref('light') // 'light' | 'dark'
const isInitialized = ref(false)

const isDarkMode = computed(() => theme.value === 'dark')

const toggleTheme = () => {
    theme.value = theme.value === 'light' ? 'dark' : 'light'
}

onMounted(() => {
    const savedTheme = localStorage.getItem('theme')
    const initialTheme = savedTheme || 'light' // Default to light theme

    theme.value = initialTheme
    isInitialized.value = true
})

watch([theme, isInitialized], ([newTheme, newIsInitialized]) => {
    if (newIsInitialized) {
        localStorage.setItem('theme', newTheme)
        if (newTheme === 'dark') {
            document.documentElement.classList.add('dark')
        } else {
            document.documentElement.classList.remove('dark')
        }
    }
})

provide('theme', {
    isDarkMode,
    toggleTheme,
})
</script>

<script>
import { inject } from 'vue'

export function useTheme() {
    const theme = inject('theme')
    if (!theme) {
        throw new Error('useTheme must be used within a ThemeProvider')
    }
    return theme
}
</script>
